"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const c = __importStar(require("../constants/remoting"));
const remoting_1 = __importDefault(require("../actions/remoting"));
const safe_access_1 = __importDefault(require("safe-access"));
const js_logger_1 = __importDefault(require("js-logger"));
const config_1 = __importDefault(require("../config"));
const nucleus_1 = require("@lifesize/nucleus");
const { GALAXY_ACTION_CALL_CONNECTED, GALAXY_ACTION_PRESENTATION_FAILED, GALAXY_ACTION_PRESENTATION_TOKEN_DENIED, RTC_REMOTE_PRESENTATION_STREAM_ADDED, TOKEN_REQUEST_FAILURE, GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED, rtcIceConnectionState } = nucleus_1.nucleusConstants;
/** @type {RTCPeerConnection?} */
let peerConnection = null;
let cachedRemoteIceCandidates = [];
const cleanUpPeerConnection = () => {
    if (peerConnection && peerConnection.signalingState !== 'closed') {
        peerConnection.close();
    }
    peerConnection = null;
};
/**
 * an incoming offer has been received by the display
 * @param {Object} store - Redux store
 */
const handleOffer = (store, payload) => {
    var _a;
    // create the new peer connection (any open peerConnection will first be cleaned up)
    js_logger_1.default.info('handling new wireless presentation offer');
    createPeerConnection(store);
    (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.setRemoteDescription(new window.RTCSessionDescription(payload)).then(() => { var _a; return (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.createAnswer(); }).then(answer => {
        var _a;
        if (answer)
            (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.setLocalDescription(answer);
    }).then(() => handleIceCandidate()).then(() => {
        var _a, _b;
        store.dispatch(remoting_1.default.sendToDisplay.wireless.answer((_a = peerConnection) === null || _a === void 0 ? void 0 : _a.localDescription));
        js_logger_1.default.info('sent sdp answer:', (_b = peerConnection) === null || _b === void 0 ? void 0 : _b.localDescription);
    }).catch(js_logger_1.default.error);
};
const handleAnswer = (store, payload) => __awaiter(void 0, void 0, void 0, function* () {
    if (peerConnection) {
        yield peerConnection.setRemoteDescription(new window.RTCSessionDescription(payload));
        handleIceCandidate();
    }
});
/**
 * stops a wireless presentation on the presenter
 * - the html button on the presenter has been clicked, or
 * - the "Stop Sharing" button on the extension has been clicked, or
 * - a change in the remote state on the display (in which case onlyEndSelf will be true) has ended the presentation
 * @param {Object} store - Redux store
 */
const handleStopSharing = (store, payload) => {
    const onlyEndSelf = safe_access_1.default(payload, 'onlyEndSelf');
    if (!onlyEndSelf) {
        // end the presentation on the display
        store.dispatch(remoting_1.default.sendToDisplay.wireless.end());
    }
    // if the html button was used to stop the presentation, close the extension bar
    const presentationTrack = safe_access_1.default(peerConnection, 'getSenders()[0].track');
    if (presentationTrack)
        presentationTrack.stop();
    // clean up the presenter's peer connection
    cleanUpPeerConnection();
};
/**
 * stops a wireless presentation on the display
 * - stops the presentation stream,
 * - cleans up the peer connection,
 * - updates the redux state (which updates the remoting state, which updates the presenter(s))
 * @param {Object} store - Redux store
 */
const stopWirelessPresentation = store => {
    const hasWirelessPresentation = safe_access_1.default(store.getState(), 'app.remoting.wirelessPresentation.receiving');
    if (hasWirelessPresentation) {
        store.dispatch({ type: c.actions.WIRELESS_PRESENTATION_EXCHANGE_PRESENTER, payload: { newPresenter: null } });
        store.dispatch({ type: c.actions.WIRELESS_PRESENTATION_STREAM_ENDED });
    }
};
const createPeerConnection = store => {
    const state = store.getState();
    const iceServers = safe_access_1.default(state, 'nucleus.galaxy.capabilities.iceServers') || [];
    cleanUpPeerConnection();
    peerConnection = new window.RTCPeerConnection(Object.assign({ iceServers: iceServers }, config_1.default.rtcPeerConnectionOptions));
    // now using the ontrack() method (peerConnection.onaddstream() was deprecated)
    peerConnection.ontrack = e => store.dispatch({
        type: c.actions.WIRELESS_PRESENTATION_ON_STREAM,
        payload: safe_access_1.default(e, 'streams[0]')
    });
    peerConnection.onicecandidate = e => {
        if (e.candidate) {
            store.dispatch(remoting_1.default.sendToDisplay.wireless.ice(e.candidate));
        }
    };
    peerConnection.oniceconnectionstatechange = () => {
        const iceConnectionState = safe_access_1.default(peerConnection, 'iceConnectionState');
        js_logger_1.default.info('wireless presentation peer connection ice state changed:', iceConnectionState);
        /* if the peerConnection has been lost, stop the presentation on the display and presenter independently
         * (because it may be due to a connection failure) */
        store.dispatch({ type: c.actions.WIRELESS_PRESENTATION_ICE_STATE_CHANGE, payload: iceConnectionState });
        if (iceConnectionState === rtcIceConnectionState.disconnected ||
            iceConnectionState === rtcIceConnectionState.failed) {
            const state = store.getState();
            const { sending, receiving } = safe_access_1.default(state, 'app.remoting.wirelessPresentation') || {};
            const isDisplay = safe_access_1.default(state, 'app.remoting.pairing.isDisplay');
            if (isDisplay && receiving) {
                stopWirelessPresentation(store);
            }
            else if (!isDisplay && sending) {
                store.dispatch({ type: c.actions.WIRELESS_PRESENTATION_SEND_END, payload: { onlyEndSelf: true } });
            }
        }
    };
};
/**
 * handleIceCandidate
 * This function takes a remote ice candidate and appends it to the cached list of remote candidates.
 * If a peer connection is ready to accept remote candidates by detecting if a remotedescription has a type,
 * the function will then process the array of remote candidates by adding them to the peer connection.
 * The function clones and clears the cached array when it process the candidates.
 */
const handleIceCandidate = (store, payload) => __awaiter(void 0, void 0, void 0, function* () {
    if (payload)
        cachedRemoteIceCandidates = cachedRemoteIceCandidates.concat([payload]);
    if (!safe_access_1.default(peerConnection, 'remoteDescription.type') || !cachedRemoteIceCandidates.length)
        return;
    const clonedRemoteIceCandidates = JSON.parse(JSON.stringify(cachedRemoteIceCandidates));
    cachedRemoteIceCandidates = [];
    const addIceCandidatePromises = clonedRemoteIceCandidates.map(candidate => { var _a; return (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.addIceCandidate(new window.RTCIceCandidate(candidate)); });
    return yield Promise.all(addIceCandidatePromises);
});
const handleCreateOffer = (store, localStream) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    try {
        if (!(localStream instanceof MediaStream)) {
            throw new Error('Payload for WIRELESS_PRESENTATION_CREATE_OFFER needs to be a MediaStream');
        }
        const track = localStream.getVideoTracks()[0];
        if (track) {
            track.onended = () => {
                // presentation is ended via the "Stop Sharing" button generated by the extension
                // dispatch the same action as if the html button been pressed
                store.dispatch({ type: c.actions.WIRELESS_PRESENTATION_SEND_END });
            };
        }
        store.dispatch({ type: c.actions.WIRELESS_PRESENTATION_SEND_START, payload: localStream });
        createPeerConnection(store);
        // now using the addTrack() method (peerConnection.addStream() was deprecated)
        localStream.getTracks().forEach(track => { var _a; return (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.addTrack(track, localStream); });
        const offer = yield ((_a = peerConnection) === null || _a === void 0 ? void 0 : _a.createOffer({ offerToReceiveVideo: true }));
        if (offer)
            yield ((_b = peerConnection) === null || _b === void 0 ? void 0 : _b.setLocalDescription(offer));
        store.dispatch(remoting_1.default.sendToDisplay.wireless.offer((_c = peerConnection) === null || _c === void 0 ? void 0 : _c.localDescription));
        js_logger_1.default.info('send sdp offer:', (_d = peerConnection) === null || _d === void 0 ? void 0 : _d.localDescription);
    }
    catch (e) {
        js_logger_1.default.error(e);
    }
});
const handleCallConnected = store => {
    // wireless presentation upon call connection
    const hasWirelessPresentation = safe_access_1.default(store.getState(), 'app.remoting.wirelessPresentation.receiving');
    if (hasWirelessPresentation) {
        js_logger_1.default.info('trying to start presentation after call starts');
        /* note: this delay is necessary to avoid a failure for START_PRESENTATION in the rtc middleware due to
         * "sdp_update_in_progress" */
        setTimeout(() => store.dispatch(nucleus_1.streamActions.startPresentation('', '')), 2000);
    }
};
/*
 * while simultaneously starting a presentation wirelessly (in a call) and remotely, there is a case where
 * WIRELESS_PRESENTATION_ON_STREAM has occurred, but no token request or denial follows, then
 * RTC_REMOTE_PRESENTATION_STREAM_ADDED, so in this case we know that the remote presentation has 'won' and we should
 * stop the wireless presentation (otherwise, you may have a wireless presentation (not attached to the call) shown over
 * the remote in-call presentation)
 */
const actionMap = {
    [c.actions.WIRELESS_PRESENTATION_ANSWER_RECEIVED]: handleAnswer,
    [c.actions.WIRELESS_PRESENTATION_CREATE_OFFER]: handleCreateOffer,
    [c.actions.WIRELESS_PRESENTATION_ICECANDIDATE]: handleIceCandidate,
    [c.actions.WIRELESS_PRESENTATION_OFFER_RECEIVED]: handleOffer,
    [c.actions.WIRELESS_PRESENTATION_SEND_END]: handleStopSharing,
    [c.actions.WIRELESS_PRESENTATION_STOP]: stopWirelessPresentation,
    [c.actions.WIRELESS_PRESENTATION_STREAM_ENDED]: cleanUpPeerConnection,
    [GALAXY_ACTION_CALL_CONNECTED]: handleCallConnected,
    [GALAXY_ACTION_PRESENTATION_TOKEN_DENIED]: stopWirelessPresentation,
    [GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED]: stopWirelessPresentation,
    [TOKEN_REQUEST_FAILURE]: stopWirelessPresentation,
    [GALAXY_ACTION_PRESENTATION_FAILED]: stopWirelessPresentation,
    [RTC_REMOTE_PRESENTATION_STREAM_ADDED]: stopWirelessPresentation
};
const wirelessPresentationMiddleware = store => next => action => {
    const result = next(action);
    const handler = actionMap[action.type];
    if (handler) {
        handler(store, action.payload);
    }
    return result;
};
exports.default = wirelessPresentationMiddleware;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/middlewares/wireless-presentation.js
// module id = 601
// module chunks = 0